import { BULK_MESSAGE_QUERY } from "@/api/queries/bulkMessage";
import { basicFormatting } from "@/pages/BulkMessaging/utils/apiHelpers";
import { useQuery } from "@apollo/client";

export function useBulkMessage(bulkMessageId?: string) {
  const { data, loading, error } = useQuery(BULK_MESSAGE_QUERY, {
    variables: { bulkMessageId: bulkMessageId ?? "" },
    skip: !bulkMessageId,
  });

  if (data?.node?.__typename === "BulkMessage") {
    return { data: basicFormatting(data), loading, error };
  } else {
    return { loading, error };
  }
}
